import { render, staticRenderFns } from "./BalancesPlanDetails.vue?vue&type=template&id=5f0d4584&"
import script from "./BalancesPlanDetails.vue?vue&type=script&lang=js&"
export * from "./BalancesPlanDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports